<template>
  <div class="article-filters-pane__right_section">
    <div
      v-tooltip.top="'Language'"
      class="dropdown option_dropdown default_style_dropdown"
    >
      <div
        class="dropdown_header d-flex align-items-center"
        data-toggle="dropdown"
      >
        <i class="flag_icon icon_first far fa-globe"></i>
        <span class="text">{{ languageTitle }}</span>
        <span class="ml-auto">
          <i class="dropdown_arrow icon_last cs-angle-down"></i>
        </span>
      </div>

      <div class="dropdown-menu dropdown-menu-right">
        <ul class="inner">
          <li
            v-for="language in languages"
            class="list_item"
            :value="language.code"
            @click.prevent="changeTwitterLanguageRoute(language)"
          >
            <a v-if="languages.length > 0" href="#">{{ language.languageName }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import sortBy from 'lodash.sortby'
import { twitterLanguages } from '../../../../config/twitter-languages'

export default {
  data () {
    return {
      languageTitle: 'All',
      languages: twitterLanguages
    }
  },
  computed: {
    getSortedTwitterLanguageList () {
      return sortBy(this.languages, ['languageName'], ['asc'])
    }
  },
  methods: {
    changeTwitterLanguageRoute (language) {
      this.languageTitle = language.languageName
      this.$router.replace({
        query: { ...this.$route.query, language: language.code }
      })
    }
  }
}
</script>
